/**
 * Local SVG data-URI placeholders for missing dish images (avoids external via.placeholder.com).
 */
const svgPlaceholder = (size) =>
    "data:image/svg+xml," +
    encodeURIComponent(
        `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 ${size} ${size}">` +
            `<rect fill="%23e5e7eb" width="100%" height="100%"/>` +
            `<path fill="%239ca3af" d="M${size * 0.28} ${size * 0.72}L${size * 0.5} ${size * 0.28}l${size * 0.22} ${size * 0.44}H${size * 0.28}z"/>` +
            `</svg>`
    );

export const DISH_IMAGE_PLACEHOLDER_40 = svgPlaceholder(40);
export const DISH_IMAGE_PLACEHOLDER_48 = svgPlaceholder(48);
export const DISH_IMAGE_PLACEHOLDER_64 = svgPlaceholder(64);
/** Wide card-style placeholder (280x160) */
export const DISH_IMAGE_PLACEHOLDER_WIDE =
    "data:image/svg+xml," +
    encodeURIComponent(
        '<svg xmlns="http://www.w3.org/2000/svg" width="280" height="160" viewBox="0 0 280 160">' +
            '<rect fill="%23e5e7eb" width="280" height="160"/>' +
            '<text x="140" y="88" text-anchor="middle" fill="%239ca3af" font-family="system-ui,sans-serif" font-size="14">No image</text>' +
            "</svg>"
    );

/** Hero/detail placeholder (800x400) */
export const DISH_IMAGE_PLACEHOLDER_HERO =
    "data:image/svg+xml," +
    encodeURIComponent(
        '<svg xmlns="http://www.w3.org/2000/svg" width="800" height="400" viewBox="0 0 800 400">' +
            '<rect fill="%23e5e7eb" width="800" height="400"/>' +
            '<text x="400" y="210" text-anchor="middle" fill="%239ca3af" font-family="system-ui,sans-serif" font-size="24">No image</text>' +
            "</svg>"
    );
